import { DicRecord } from '@entities/dictionaries';

export type Address = {
  city: DicRecord;
  street: string;
  home: string;
  apartment: string;
};

export type EducationDetails = {
  //city: DicRecord;
  isBachelor: boolean;
  degreeType: DicRecord;
  school: string;
  year: DicRecord;
  field: DicRecord;
  otherField: string;
  additionalField: DicRecord;
  additionalAnotherFieldOfStudy: string;
};

export type PersonalInfo = {
  userId: string;
  birthday: any; //string | Date | null;
  firstName: string;
  lastName: string;
  //sector: DicRecord;
  gender: string;
  phone: string;
  phoneAdditional: string;
  email: string;
  addressById: Address;
  addressWhileStudying: Address;
  addressesMatch: boolean;
  educationDetails: EducationDetails;
  //learningDisabilityCertificate: boolean;
  birthdayHebrew: string;
  isUnder18address: boolean;
  under18City: DicRecord;
  under18District: DicRecord;
  under18Home: string;
  under18Street: string;
  under18Confirm: boolean;
  neighborhoodConfirmCheckbox: boolean;
  receivedAchievementsAdvising: boolean;
  isReligiousSector: boolean;
  studyStartSemester: DicRecord;
  masterTrackType: DicRecord;
};

export type SendPersonalInfoResponse = {
  type: string;
  form_data: string;
  process_id: number;
  user_id: number;
  id: number;
  error?: any;
};

export type PersonalInfoResponse = PersonalInfoRequest & {
  id: number;
  user: {
    cognito_id: string;
    identity_number: string;
    phone: string;
    email: string;
    role: string;
    status: string;
    terms: number;
    register_period: number;
    id: number;
  };
};

export type AddressRequest = {
  city: string;
  street: string;
  house_number: string;
  apartment_number: string;
};

export type PersonalInfoRequest = {
  first_name: string;
  last_name: string;
  //identity_number: string;
  birthdate: string | null;
  gender: string;
  //sector_id?: number | string;
  phone: string;
  additional_phone: string;
  // email: string;
  city_symbol?: number | string;
  street: string;
  house_number: string;
  apartment_number: string;
  study_city_symbol?: number | string;
  study_street: string;
  study_house_number: string;
  study_apartment_number: string;
  //educational_city_id?: number | string;
  is_ba: boolean;
  currently_studying?: string;
  study_year_number: string;
  study_start_semester?: string | null;
  master_track_type?: string | null;
  //learning_disability_certificate?: boolean;
  field_of_study_id?: number | string;
  another_field_of_study: string;
  additional_field_of_study_id: string | number;
  additional_another_field_of_study: string;
  age_18_city_symbol: number | '' | null;
  age_18_neighborhood_symbol: number | '' | null;
  age_18_street: string;
  age_18_house_number: string;
  age_18_not_israel: boolean;
  age_18_correctness_information: boolean;
  // neighborhood_confirm_correctness_information: boolean;
  received_achievements_advising: boolean;
  is_religious_sector: boolean;
  birthdate_hebrew?: string;
};

export enum DegreeType {
  BACHELOR = 'BACHELOR',
  MASTER = 'MASTER',
}

export enum StudyStartSemester {
  SEMESTER_A = 'SEMESTER_A',
  SEMESTER_B = 'SEMESTER_B',
}

export enum MasterTrackType {
  RESEARCH = 'RESEARCH',
  NON_RESEARCH = 'NON_RESEARCH',
}
